/* Programme A/B (11/10/2026), test « livraison-1 », version B « seuil50 » : livraison 4,90 € sous 50 €, offerte dès 50 €.
 * Shopify ne sait pas changer les frais selon le visiteur : la version B met au panier des COPIES des produits (handle
 * « …-lb »), rattachées à une règle de livraison à part (payante sous 50 €). Les originaux restent en livraison offerte.
 * Ce script (chargé tôt, sans defer, par layout/theme.liquid) remplace, en version B seulement, chaque variante originale
 * par sa copie dans toutes les écritures du panier : /cart/add (JSON id / items, FormData, texte), /cart/update (updates),
 * /cart/change (id), par fetch, XMLHttpRequest ou formulaire classique.
 * Table : window.RS_LIV.v = { "<variante originale>": <variante copie> }, écrite par Liquid depuis le métachamp boutique
 * cro.livraison_copies (docs/projet-ab-testing/copies-livraison.json). Version A et visiteurs non tirés : rien ne change.
 */
(function () {
  var H = document.documentElement, T = (window.RS_LIV && window.RS_LIV.v) || {}, VL = H.getAttribute('data-v-livraison');
  if (!VL || !Object.keys(T).length) return;

  /* ── Panier d'une autre version (changement de version forcé en recette, panier gardé d'avant le tirage) : les lignes
   * de l'autre version sont remplacées une fois au chargement, sinon les frais ne correspondent pas à la version vue
   * (originaux en B = aucun frais ni barre ; copies en A = 4,90 € facturés). Une ligne à la fois (les écritures
   * simultanées du panier se perdent), propriétés gardées ; le tiroir est re-rendu par rs-programme-ab.js. */
  var INV = {};
  Object.keys(T).forEach(function (k) { INV[String(T[k])] = k; });
  var VERS = VL === 'seuil50' ? T : INV;
  function migrer() {
    var F = window.fetch.bind(window), J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    F('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var a = (cart.items || []).filter(function (it) { return VERS[String(it.variant_id)]; });
      return a.reduceRight(function (p, it) {
        return p.then(function () {
          return F('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify({ id: it.key, quantity: 0 }) });
        }).then(function () {
          return F('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: J,
            body: JSON.stringify({ items: [{ id: +VERS[String(it.variant_id)], quantity: it.quantity, properties: it.properties || {} }] }) });
        });
      }, Promise.resolve());
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', migrer); else migrer();
  if (VL !== 'seuil50') return;
  function c(id) { var k = String(id).trim(); return /^\d+$/.test(k) && T[k] ? String(T[k]) : null; }
  function cart(url) { url = String(url || ''); return /\/cart\/(add|update|change)(\.js)?(\?|$)/.test(url.split('#')[0]) ? url : ''; }

  function objet(o, route) {
    if (!o || typeof o !== 'object') return false;
    var ch = false;
    if (route !== 'update' && o.id != null && c(o.id)) { o.id = typeof o.id === 'number' ? +c(o.id) : c(o.id); ch = true; }
    if (Array.isArray(o.items)) o.items.forEach(function (it) { if (it && it.id != null && c(it.id)) { it.id = +c(it.id); ch = true; } });
    if (o.updates && typeof o.updates === 'object' && !Array.isArray(o.updates)) {
      var u = {};
      // Seulement les ajouts (quantité > 0) : retirer une variante originale déjà au panier doit rester possible.
      Object.keys(o.updates).forEach(function (k) { var n = c(k); if (n && +o.updates[k] > 0) { u[n] = o.updates[k]; ch = true; } else u[k] = o.updates[k]; });
      o.updates = u;
    }
    return ch;
  }
  function params(p, route) {
    var ch = false;
    p.forEach(function (val, key) {
      if ((key === 'id' && route !== 'update') || /^items\[\d+\]\[id\]$/.test(key)) { var n = c(val); if (n) { p.set(key, n); ch = true; } }
    });
    if (route === 'update') {
      var a = [];
      p.forEach(function (val, key) { var m = /^updates\[(\d+)\]$/.exec(key); if (m && c(m[1]) && +val > 0) a.push([key, 'updates[' + c(m[1]) + ']', val]); });
      a.forEach(function (x) { p.delete(x[0]); p.append(x[1], x[2]); ch = true; });
    }
    return ch;
  }
  function route(url) { var m = /\/cart\/(add|update|change)/.exec(url); return m ? m[1] : ''; }
  function corps(body, url) {
    var r = route(url);
    try {
      if (window.FormData && body instanceof FormData) { params(body, r); return body; }
      if (window.URLSearchParams && body instanceof URLSearchParams) { params(body, r); return body; }
      if (typeof body === 'string' && body) {
        var s = body.trim();
        if (s.charAt(0) === '{') { var o = JSON.parse(s); return objet(o, r) ? JSON.stringify(o) : body; }
        var p = new URLSearchParams(s); return params(p, r) ? p.toString() : body;
      }
    } catch (e) {}
    return body;
  }

  var _fetch = window.fetch;
  if (_fetch) window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (cart(url) && init && init.body != null) { init = Object.assign({}, init, { body: corps(init.body, url) }); return _fetch.call(this, input, init); }
    return _fetch.apply(this, arguments);
  };
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this._rsLiv = cart(url); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (b) { if (this._rsLiv && b != null) b = corps(b, this._rsLiv); return _send.call(this, b); };

  // Formulaire envoyé sans AJAX (repli du thème) : le champ id est remplacé juste avant l'envoi.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !cart(f.getAttribute('action') || '')) return;
    [].forEach.call(f.querySelectorAll('[name="id"], [name^="items["][name$="[id]"]'), function (x) {
      var n = c(x.value);
      if (!n) return;
      if (x.tagName === 'SELECT') {
        // Le menu ne contient pas la copie : on passe par un champ caché pour cet envoi.
        var h = document.createElement('input'); h.type = 'hidden'; h.name = x.name; h.value = n; x.name = ''; f.appendChild(h);
        setTimeout(function () { x.name = h.name; h.remove(); }, 0);
      } else { var o = x.value; x.value = n; setTimeout(function () { x.value = o; }, 0); }
    });
  }, true);

  /* ── Textes : « Livraison offerte » devient « Livraison offerte dès 50 € » partout où le thème la promet (réglages de
   * sections traduits, clés de langue, textes écrits par le JS : ruban, sticky…), dans les 12 langues. Les blocs du test
   * (barre du tiroir, frais) portent data-rsliv-garder et ne sont pas réécrits. Le seuil reste en euros (paiement en EUR). */
  var L = (H.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();
  var DICO = {
    fr: [/livraison (?:offerte|gratuite)(?: partout en France| en France métropolitaine| partout)?(?! dès)/gi, 'livraison offerte dès 50 €'],
    en: [/free (?:worldwide )?(?:shipping|delivery)(?: worldwide)?(?! from)/gi, 'free shipping from €50'],
    de: [/kostenlose[rn]? (?:Versand|Lieferung)(?! ab)/gi, 'kostenloser Versand ab 50 €'],
    es: [/env[ií]o gratis(?! desde)/gi, 'envío gratis desde 50 €'],
    it: [/spedizione gratuita(?! da)/gi, 'spedizione gratuita da 50 €'],
    nl: [/gratis verzending(?! vanaf)/gi, 'gratis verzending vanaf € 50'],
    pl: [/darmowa dostawa(?! od)/gi, 'darmowa dostawa od 50 €'],
    cs: [/doprava zdarma(?! od)/gi, 'doprava zdarma od 50 €'],
    da: [/gratis (?:levering|fragt)(?! fra)/gi, 'gratis levering fra 50 €'],
    fi: [/ilmainen toimitus(?! yli)/gi, 'ilmainen toimitus yli 50 €:n tilauksiin'],
    no: [/gratis frakt(?! fra)/gi, 'gratis frakt fra 50 €'],
    nb: [/gratis frakt(?! fra)/gi, 'gratis frakt fra 50 €'],
    sv: [/fri frakt(?! från)/gi, 'fri frakt från 50 €']
  };
  var R = DICO[L] || DICO.fr, SAUF = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TEMPLATE)$/;
  function texte(n) {
    var p = n.parentNode;
    if (!p || p.nodeType !== 1 || SAUF.test(p.nodeName) || (p.closest && p.closest('[data-rsliv-garder]'))) return;
    var t = n.nodeValue;
    if (!t || t.length < 8) return;
    R[0].lastIndex = 0;
    if (!R[0].test(t)) return;
    R[0].lastIndex = 0;
    n.nodeValue = t.replace(R[0], function (m) { return m.charAt(0) === m.charAt(0).toUpperCase() && m.charAt(0) !== m.charAt(0).toLowerCase() ? R[1].charAt(0).toUpperCase() + R[1].slice(1) : R[1]; });
  }
  function parcourir(el) {
    if (el.nodeType === 3) { texte(el); return; }
    if (el.nodeType !== 1 || SAUF.test(el.nodeName)) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, a = [];
    while ((n = w.nextNode())) a.push(n);
    a.forEach(texte);
  }
  if (window.MutationObserver) new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'characterData') texte(m.target);
      else [].forEach.call(m.addedNodes, parcourir);
    });
  }).observe(H, { childList: true, subtree: true, characterData: true });
  if (document.body) parcourir(document.body);

  window.rsLivraison = { copie: c, texte: parcourir };
})();
